import styles from "./BookingHandoffCard.module.css";

interface HandoffSummary {
    center: string;
    package: string;
    date: string;
    time: string;
    price: number;
}

interface BookingHandoffCardProps {
    summary: HandoffSummary;
    portalUrl: string;
}

const formatPrice = (price: number) => {
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
    }).format(price);
};

export const BookingHandoffCard = ({ summary, portalUrl }: BookingHandoffCardProps) => {
    const handleProceed = () => {
        window.open(portalUrl, "_blank", "noopener,noreferrer");
    };

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <span className={styles.icon}>📋</span>
                <span>Ready to Book</span>
            </div>
            <div className={styles.details}>
                <div className={styles.row}>
                    <span className={styles.label}>Center</span>
                    <span className={styles.value}>{summary.center}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.label}>Package</span>
                    <span className={styles.value}>{summary.package}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.label}>Date</span>
                    <span className={styles.value}>{summary.date}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.label}>Time</span>
                    <span className={styles.value}>{summary.time}</span>
                </div>
                <div className={styles.row}>
                    <span className={styles.label}>Price</span>
                    <span className={styles.value}>{formatPrice(summary.price)}</span>
                </div>
            </div>
            <div className={styles.note}>
                ⓘ Final registration and payment are completed on the NURA portal (opens in a new tab).
            </div>
            <button
                type="button"
                className={styles.cta}
                onClick={handleProceed}
                aria-label="Open NURA portal in a new tab"
            >
                Proceed to NURA Portal →
            </button>
        </div>
    );
};
